import api from './api';

export interface RoastStage {
  name: string;
  temperature: number;
  time: number;
  description?: string;
}

export interface RoastProfile {
  id: string;
  name: string;
  roastDate: string;
  roastLevel: string;
  notes: string;
  stages: RoastStage[];
  type: 'ItemType' | 'LotType' | 'SampleType';
  inventory_item_id?: string;
  lot_id?: string;
  sample_id?: string;
  created_at: string;
  updated_at: string;
}

export interface CreateRoastProfileDTO {
  name?: string;
  roastDate: string;
  roastLevel?: string;
  notes: string;
  stages: RoastStage[];
  type: 'ItemType' | 'LotType' | 'SampleType';
  inventory_item_id?: string;
  lot_id?: string;
  sample_id?: string;
  data?: string;
}

export interface UpdateRoastProfileDTO {
  name?: string;
  roastDate: string;
  roastLevel?: string;
  notes: string;
  stages: RoastStage[];
}

export interface CuppingProfile {
  id: string;
  cupping_type: string;
  cupping_date: string;
  score: number;
  notes: string;
  descriptors: string;
  fragrance_aroma: number;
  flavor: number;
  aftertaste: number;
  acidity: number;
  sweetness: number;
  body: number;
  roast_defect_underdevelopment?: number;
  roast_defect_overdevelopment?: number;
  roast_defect_baked?: number;
  roast_defect_scorched?: number;
  mouthfeel: number;
  balance: number;
  overall: number;
  roast_level: number;
  is_qc_passed?: boolean;
  fragrance: number;
  aroma: number;
  extended_data?: Record<string, unknown>;
  defects?: string[];
  flavor_notes?: string[];
  mouthfeel_notes?: string[];
  type: string;
  cupping_session_id?: string;
  inventory_item_id?: string;
  lot_id?: string;
  sample_id?: string;
  created_at: string;
  updated_at: string;
}

export const profileService = {
  // Roast Profiles
  createRoastProfile: async (data: CreateRoastProfileDTO): Promise<RoastProfile> => {
    console.log("ROAST PAYLOAD", data);
    const response = await api.post('/profiles/roast', data);
    return response.data;
  },

  updateRoastProfile: async (id: string, data: UpdateRoastProfileDTO): Promise<RoastProfile> => {
    const response = await api.put(`/profiles/roast/${id}`, data);
    return response.data;
  },

  getRoastProfileByEntity: async (entityType: string, entityId: string): Promise<RoastProfile> => {
    const response = await api.get(`/profiles/roast/${entityType}/${entityId}`);
    return response.data;
  },
  
  // Cupping Profiles
  createCuppingProfile: async (data: Omit<CuppingProfile, 'id' | 'created_at' | 'updated_at'>): Promise<CuppingProfile> => {
    console.log("CUPPING PAYLOAD", data);
    const response = await api.post<CuppingProfile>('/profiles/cupping', data);
    return response.data;
  },

  updateCuppingProfile: async (id: string, data: Partial<Omit<CuppingProfile, 'id' | 'created_at' | 'updated_at'>>): Promise<CuppingProfile> => {
    const response = await api.put<CuppingProfile>(`/profiles/cupping/${id}`, data);
    return response.data;
  },

  getCuppingProfileByEntity: async (entityType: string, entityId: string): Promise<CuppingProfile[]> => {
    const response = await api.get<CuppingProfile[]>(`/profiles/cupping/${entityType}/${entityId}`);
    return response.data;
  },

  getAllCuppingProfiles: async (): Promise<CuppingProfile[]> => {
    const response = await api.get<CuppingProfile[]>('/profiles/cupping');
    return response.data;
  }
};
